import { render, staticRenderFns } from "./legalAndMap.vue?vue&type=template&id=58ca507d&scoped=true&"
import script from "./legalAndMap.vue?vue&type=script&lang=js&"
export * from "./legalAndMap.vue?vue&type=script&lang=js&"
import style0 from "./legalAndMap.vue?vue&type=style&index=0&id=58ca507d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca507d",
  null
  
)

export default component.exports